<template>
  <v-dialog v-model="dialog" fullscreen persistent>
    <template v-slot:activator="{ on, attrs }">
      <!-- :class="btnClass" -->
      <v-btn
        :elevation="hasCustomization ? '0' : '2'"
        :class="hasCustomization ? 'btnClass' : ''"
        v-on="on"
        v-bind="attrs"
        small
      >
        <v-icon>
          mdi-magnify
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-app-bar dense fixed>
        <div class="title text">
          <span v-if="parent == 'freespins'">
            {{ $t("campaing") }}: {{ freespin.title }}
          </span>
          <span v-else>{{ $t("usersByCampaign") }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="mr-1" small icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container class="mt-8">
        <div v-if="errorMsg">
          <v-alert dense type="info" color="warning" class="mt-4">
            {{ errorMsg }}
          </v-alert>
        </div>

        <v-card
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'margin: auto; margin-top: 24px;'
              : 'width: 100%; margin: auto; margin-top: 24px;'
          "
        >
          <v-data-table
            :headers="headers"
            :items="datatableItems"
            :search="search"
            item-key="id_usuario"
            :loading="loading"
            :footer-props="{
              'items-per-page-text': $t('rowsPerPage'),
            }"
            :no-data-text="$t('noDataFount')"
            :hide-default-footer="parent != 'freespins'"
            :items-per-page="parent != 'freespins' ? 100 : 10"
            class="elevation-10"
          >
            <template v-slot:loading>
              <span v-if="parent == 'freespins'">
                {{ $t('freespins.adhesionsLoading') }}
              </span>
              <span v-else>{{ $t("loadingData") }}</span>
            </template>
            <template v-slot:no-results>
              {{ $t("noDataFount") }}
            </template>

            <template v-slot:top>
              <div class="pa-3">
                <v-row no-gutters class="d-flex align-center">
                  <div v-if="parent == 'freespins'" class="d-flex flex-column">
                    <div class="d-flex flex-column subtitle-2">
                      {{
                        $t("freespins.finalFreespinDate", {
                          date: freespin.date_final,
                        })
                      }}
                    </div>
                    <div class="d-flex flex-column subtitle-2">
                      {{ $t("freespins.campaignId") }}:
                      {{ freespin.campaign_id }}
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-col
                    cols="12"
                    lg="3"
                    md="4"
                    :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('search')"
                      single-line
                      hide-details
                      dense
                      solo-inverted
                      clearable
                    ></v-text-field>
                  </v-col>

                  <div style="width: 100%;">
                    <GroupExport
                      v-if="parent == 'freespins'"
                      :hideWeb="true"
                      class="my-3"
                    />
                    <div
                      class="d-flex justify-end"
                      :class="{'mt-3' : parent != 'freespins'}"
                    >
                      <v-btn
                        class="info"
                        small
                        :disabled="loadingExport || loading"
                        :loading="loadingExport || loading"
                        @click="handleExportDoc()"
                      >
                        <v-icon small left>mdi-file-export</v-icon>
                        {{ $t("claimExport") }}
                      </v-btn>
                    </div>
                  </div>
                </v-row>
              </div>
            </template>

            <!-- campaigns -->
            <template v-slot:[`item.affiliate_id`]="{ item }">
              <v-btn @click="$copy(item.affiliate_id)" x-small>
                {{ item.affiliate_id }}
              </v-btn>
            </template>

            <template v-slot:[`item.player_id`]="{ item }">
              <v-btn @click="$copy(item.player_id)" x-small>
                {{ item.player_id }}
              </v-btn>
            </template>

            <template v-slot:[`item.player_register`]="{ item }">
              {{ $handleDate(item.player_register).date }}
            </template>

            <template v-slot:[`item.player_last_login`]="{ item }">
              {{ $handleDate(item.player_last_login).date }}
            </template>

            <template v-slot:[`item.campaign_link`]="{ item }">
              <v-btn
                x-small
                @click="$copy(item.campaign_link)"
                style="text-transform: none;"
              >
                <span class="text-truncate" style="max-width: 200px;">
                  {{ item.campaign_link }}
                </span>
              </v-btn>
            </template>

            <!-- freespins -->
            <template v-slot:[`header.user_claimed_date`]="{ header }">
              <div class="d-flex align-center">
                <div>
                  <span>
                    {{ header.text }}
                  </span>
                </div>
                <div>
                  <th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="d-print-none"
                        >
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{ $t("freespins.dateAndHour") }}
                      </span>
                    </v-tooltip>
                  </th>
                </div>
              </div>
            </template>

            <template v-slot:[`header.end_date`]="{ header }">
              <div class="d-flex align-center">
                <div>
                  <span>
                    {{ header.text }}
                  </span>
                </div>
                <div>
                  <th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="d-print-none"
                        >
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{ $t("freespins.dateAndHourEnd") }}
                      </span>
                    </v-tooltip>
                  </th>
                </div>
              </div>
            </template>

            <template v-slot:[`header.balance`]="{ header }">
              <div class="d-flex align-center">
                <div>
                  <span>
                    {{ header.text }}
                  </span>
                </div>
                <div>
                  <th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="d-print-none"
                        >
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("finalBalance") }}</span>
                    </v-tooltip>
                  </th>
                </div>
              </div>
            </template>

            <template v-slot:[`item.user_id`]="{ item }">
              <v-btn @click="$copy(item.user_id)" x-small>
                {{ item.user_id }}
              </v-btn>
            </template>

            <template v-slot:[`item.campaign_id`]="{ item }">
              <v-btn @click="$copy(item.campaign_id)" x-small>
                {{ item.campaign_id }}
              </v-btn>
            </template>

            <template v-slot:[`item.user_claimed_date`]="{ item }">
              {{ item.user_claimed_date }}
            </template>

            <template v-slot:[`item.end_date`]="{ item }">
              {{ item.end_date }}
            </template>

            <template v-slot:[`item.freespins_qty`]="{ item }">
              <div class="d-flex justify-end">{{ item.freespins_qty }}</div>
            </template>

            <template v-slot:[`item.total_rollover`]="{ item }">
              <div class="d-flex justify-end">{{ item.total_rollover }}</div>
            </template>

            <template v-slot:[`item.games`]="{ item }">
              <SeeGames
                v-if="showSeeGames"
                :games="item.games"
              />
            </template>

            <template v-slot:[`item.balance`]="{ item }">
              {{
                Number(item.balance).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="statusUI(item.status)"
                class="white--text"
                small
              >
                {{ statusValue(item.status) }}
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <RemovePlayer
                v-if="freespin"
                :adhesion="item"
                :campaignTitle="freespin.title"
                :disabled="!cancellableStatus.includes(item.status)"
                :campaignId="freespin.campaign_id"
                @removeAdhesion="removeAdhesion"
              />
            </template>
          </v-data-table>

          <div
            v-if="showPagination"
            class="text-center"
          >
            <v-pagination
              v-model="page"
              :length="pageCount || 1"
              :total-visible="7"
              class="py-3"
              :disabled="fetchingPlayers || pageCount <= 1"
            ></v-pagination>
          </div>
        </v-card>

        <div
          v-if="freespin && datatableItems.length > 0"
          class="mt-2 d-flex justify-end ml-auto"
          :style="
            $vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 500px'
          "
        >
          <v-card
            class="d-flex flex-column pa-3"
            outlined
            style="width: 100%"
          >
            <span> {{ $t("freespins.resume") }} </span>

            <div
              v-for="(item, key) in resume"
              :key="key"
              class="d-flex justify-space-between text-subtitle-2 mt-2"
            >
              <div>
                {{ $t(`freespins.${item.text}`) }}
              </div>
              <div>
                {{ item.value }}
              </div>
            </div>
          </v-card>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import RemovePlayer from "./RemovePlayer";
import GroupExport from "@/components/common/filters/GroupExport.vue";
import SeeGames from "@/views/backoffice/shared/bonusAndPromotions/freespins/SeeGames"

export default {
  props: {
    parent: {
      type: String,
      required: true
    },
    showSeeGames: {
      type: Boolean,
      required: true
    },
    campaignId: {
      type: String
    },
    affiliateId: {
      type: String
    },
    freespin: {
      type: Object,
    },
  },

  components: {
    RemovePlayer,
    GroupExport,
    SeeGames
  },

  data: () => ({
    dialog: false,
    datatableItems: [],
    errorMsg: "",
    loading: false,
    loadingExport: false,
    resume: {},
    search: "",
    // headers: [],
    cancellableStatus: ["0", "1"],

    // campaigns pagination
    cachedPage: {},
    fetchingPlayers: false,
    totalPlayers: 0,
    timeoutId: 0,
    page: 1,
    pageCount: 0,
  }),
  computed: {
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    hasCustomization() {
      return this.parent == "affiliates";
    },
    showPagination() {
      const parents = [
        'campaigns',
        'affiliates',
      ];
      const parent = parents.some(parent => this.parent.includes(parent));

      return parent;
    },
    headers() {
      if (this.parent == "freespins") {
        return [
          { text: this.$t("idUser"), value: "user_id" },
          { text: this.$t("userName"), value: "user_name" },
          { text: this.$t("freespins.startDate"), value: "user_claimed_date" },
          { text: this.$t("freespins.endDate"), value: "end_date" },
          { text: this.$t("freespins.roundsQuantity"), value: "freespins_qty"},
          { text: this.$t("totalRollover"), value: "total_rollover" },
          { text: this.$t("games"), value: "games" },
          { text: this.$t("balanceReport"), value: "balance" },
          { text: "Status", value: "status" },
          // { text: "Extrato", value: "data-table-expand" },
          { text: this.$t("actions"), value: "actions", sortable: false }
        ]
      }

      if (this.parent == "campaigns") {
        return [
          { text: this.$t("idAffiliate"), value: "affiliate_id", align: "no-wrap"},
          { text: this.$t("name"), value: "affiliate_name", align: "no-wrap"},
          { text: this.$t("freespins.campaignId"), value: "campaign_id", align: "no-wrap"},
          { text: this.$t("campaing"), value: "campaign_name", align: "no-wrap"},
          { text: "Link", value: "campaign_link", align: "no-wrap"},
          { text: this.$t("playerId"), value: "player_id", align: "no-wrap"},
          { text: this.$t("name"), value: "player_nome", align: "no-wrap"},
          { text: "Registro", value: "player_register", align: "no-wrap"},
          { text: this.$t("phone"), value: "player_phone", align: "no-wrap"},
          { text: "Login", value: "player_login", align: "no-wrap"},
          { text: "Email", value: "player_email", align: "no-wrap"},
          { text: this.$t("lastLogin"), value: "player_last_login", align: "no-wrap"},
          { text: this.$t("onlineBalance"), value: "player_online_balance", align: "no-wrap"},
          { text: this.$t("bonusBalance"), value: "player_bonus_balance", align: "no-wrap"}
        ]
      }

      if (
          this.parent == "affiliates"
        ) {
        return [
          { text: this.$t("idAffiliate"), value: "affiliate_id", align: "no-wrap"},
          { text: this.$t("name"), value: "affiliate_name", align: "no-wrap"},
          { text: this.$t("freespins.campaignId"), value: "campaign_id", align: "no-wrap"},
          { text: this.$t("campaing"), value: "campaign_name", align: "no-wrap"},
          { text: "Link", value: "campaign_link", align: "no-wrap"},
          { text: this.$t("playerId"), value: "player_id", align: "no-wrap"},
          { text: this.$t("name"), value: "player_nome", align: "no-wrap"},
          { text: "Registro", value: "player_register", align: "no-wrap"},
          { text: this.$t("phone"), value: "player_phone", align: "no-wrap"},
          { text: "Login", value: "player_login", align: "no-wrap"},
          { text: "Email", value: "player_email", align: "no-wrap"},
          { text: this.$t("lastLogin"), value: "player_last_login", align: "no-wrap"},
          { text: this.$t("onlineBalance"), value: "player_online_balance", align: "no-wrap"},
          { text: this.$t("bonusBalance"), value: "player_bonus_balance", align: "no-wrap"}
        ]
      }
      return [];
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        if (this.parent == "freespins") {
          this.listAdhesions();
        }
        if (this.parent == "campaigns") {
          this.debouncedfetchTotalPlayerByCampaigns();
          this.fetchCampaignReportByCampaignId();
        }
        if (
          this.parent == "affiliates"
        ) {
          this.debouncedfetchTotalPlayerByCampaigns();
          this.fetchCampaignReportByAffiliate();
        }
      }
    },
    page() {
      if (this.parent == "campaigns") {
        this.fetchCampaignReportByCampaignId(true);
      }
      if (
        this.parent == "affiliates"
      ) {
        this.fetchCampaignReportByAffiliate(true);
      }
    },
  },
  methods: {
    debouncedfetchTotalPlayerByCampaigns() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(()=> {this.fetchTotalPlayerByCampaigns()}, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalPlayerByCampaigns() {
      this.fetchingPlayers = true;
      
      let { id, type } = this.parent == "campaigns"
        ? { id: this.campaignId, type: "campaign" }
        : { id: this.affiliateId, type: "affiliate" };
      
      const body = {
        id: id,
        type: type,
      };

      await this.$axios
        .post(`${this.$prefix()}/affiliateCampaign/countTotalPlayerByCampaigns`, this.$formdata(body))
        .then((response) => {
          this.totalPlayers = Number(response.data.dados.total_players);
          this.pageCount = Math.ceil(this.totalPlayers / 100);
          this.fetchingPlayers = false;
        })
        .catch(() => this.fetchingPlayers = false);
    },

    fetchCampaignReportByCampaignId(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }
      this.loading = true;
      this.datatableItems = [];
      const body = {
        campaign_id: this.campaignId,
      };

      body.page_number = this.page - 1;

      if (this.cachedPage[this.page]) {
        this.datatableItems = this.cachedPage[this.page]
        this.loading = false;
        return
      }

      this.$axios.post(
        `${this.$prefix()}/affiliateCampaign/campaignReportById`,
        this.$formdata(body)
      )
      .then((resp) => {
        this.loading = false;
        this.datatableItems = resp.data.dados;
        this.cachedPage[this.page] = this.datatableItems;
      })
      .catch(() => this.loading = false);
    },

    fetchCampaignReportByAffiliate(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }

      this.loading = true;

      const body = {
        affiliate_id: this.affiliateId,
      };

      body.page_number = this.page - 1;

      if (this.cachedPage[this.page]) {
        this.datatableItems = this.cachedPage[this.page]
        this.loading = false;
        return
      }

      this.$axios
        .post(
          `${this.$prefix()}/affiliateCampaign/campaignReportByAffiliate`,
          this.$formdata(body)
        )
        .then((resp) => {
          this.loading = false;
          this.datatableItems = resp.data.dados;
          this.cachedPage[this.page] = this.datatableItems;
        })
        .catch(() =>  this.loading = false)
    },

    listAdhesions() {
      this.noDataFound = false;
      this.errorMsg = null;
      this.loading = true;

      const body = {
        campaign_freespins_id: this.freespin.campaign_id,
      };

      body[`status[${0}]`] = 1;
      body[`status[${1}]`] = 2;
      body[`status[${2}]`] = 3;
      body[`status[${4}]`] = 5;

      if (this.freespin.status != "2") {
        body[`status[${3}]`] = 4;
      }

      this.$axios
        .post(
          `/${this.$prefix()}/cassino/gamesAgregation/listFreespinsUsers`,
          this.$formdata(body)
        )
        .then((response) => {
          this.datatableItems = response.data.dados;

          this.groupByUser();

          let balanceTotal = 0;
          let totalPending = 0;
          let totalActive = 0;
          let totalExpired = 0;
          let totalRemoved = 0;
          let totalFinalized = 0;

          // this.adhesions.forEach((item) => {
          this.datatableItems.forEach((item) => {
            function addDays(date, days) {
              var result = new Date(date);
              result.setDate(result.getDate() + days);
              return result;
            }

            balanceTotal += Number(item.balance);

            // resume
            if (item.status == "0") {
              totalPending += 1;
            } else if (item.status == "1") {
              totalActive += 1;
            } else if (item.status == "2") {
              totalFinalized += 1;
            } else if (item.status == "3") {
              totalExpired += 1;
            } else if (item.status == "4") {
              totalRemoved += 1;
            }

            if (!item.user_claimed_date) {
              item.user_claimed_date = this.$t("freespins.notClaimed");
              item.end_date = this.$t("freespins.notClaimed");
              return;
            }

            item.end_date = addDays(
              item.user_claimed_date,
              Number(this.freespin.expiration_days)
            );

            item.end_date = new Date(item.end_date).toLocaleTimeString([], {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });

            item.user_claimed_date = new Date(
              item.user_claimed_date.replace(" ", "T")
            ).toLocaleTimeString([], {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });
          });

          this.resume = [
            {
              text: "totalPending",
              value: totalPending,
            },
            {
              text: "totalActive",
              value: totalActive,
            },
            {
              text: "totalExpired",
              value: totalExpired,
            },
            {
              text: "totalRemoved",
              value: totalRemoved,
            },
            {
              text: "totalFinalized",
              value: totalFinalized,
            },
            {
              text: "balanceTotal",
              value: this.getPortugueseMoney(balanceTotal),
            },
          ];
        })
        .catch((error) => {
          this.errorMsg = error.response.data.messages.error;
          this.noDataFound = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleExportDoc() {
      if (this.parent == "freespins") {
        this.exportListAdhesions();
      }
      if (this.parent == "campaigns") {
        this.exportCampaignReport();
      }
      if (
        this.parent == "affiliates"
      ) {
        this.exportCampaignReportByAffiliate();
      }
    },

    async exportCampaignReport() {
      this.loadingExport = true;
      const body = {
          campaign_id: this.campaignId,
          export: "csv",
          page_number: "",
          isZip: true
        };

        await this.$request.exportDoc(
          `/${this.$prefix()}/affiliateCampaign/campaignReportById`,
          body,
          body.export
        )

        this.loadingExport = false;
    },

    async exportCampaignReportByAffiliate() {
      this.loadingExport = true;
      const body = {
          affiliate_id: this.affiliateId,
          export: "csv",
          page_number: "",
          isZip: true
        };

        await this.$request.exportDoc(
          `/${this.$prefix()}/affiliateCampaign/campaignReportByAffiliate`,
          body,
          body.export
        )

        this.loadingExport = false;
    },

    async exportListAdhesions() {
      // web
      if (!this.exportDoc) {
        this.listAdhesions();
        return;
      }

      this.loadingExport = true;

      const body = {
        campaign_freespins_id: this.freespin.campaign_id,
        export_type: this.exportDoc,
      };

      body[`status[${0}]`] = 1;
      body[`status[${1}]`] = 2;
      body[`status[${2}]`] = 3;
      body[`status[${4}]`] = 5;

      if (this.freespin.status != "2") {
        body[`status[${3}]`] = 4;
      }

      await this.$request.exportDoc(
        `/${this.$prefix()}/cassino/gamesAgregation/listFreespinsUsers`,
        body,
        body.export_type
      );

      this.loadingExport = false;
    },

    statusUI(value) {
      const map = {
        "0": "grey",
        "1": "green",
        "2": "warning",
        "3": "purple",
        "4": "grey",
        "5": "grey",
      };

      return map[value];
    },

    statusValue(value) {
      const map = {
        "0": this.$t("pending"),
        "1": this.$t("activePromo"),
        "2": this.$t("finalizedPromo"),
        "3": this.$t("expiredPromo"),
        "4": this.$t("removed"),
        "5": this.$t("freespins.inProgress"),
      };

      return map[value];
    },

    removeAdhesion({ userId }) {
      this.datatableItems = this.datatableItems.map((adhesion) => {
        if (adhesion.user_id === userId) {
          return { ...adhesion, status: "4" };
        }

        return adhesion;
      });
    },

    groupByUser() {
      function compare(a, b) {
        if (a.user_id < b.user_id) {
          return -1;
        }
        if (a.user_id > b.user_id) {
          return 1;
        }
        return 0;
      }

      this.datatableItems.sort(compare);
    },

    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
<style scoped>
.text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.btnClass {
  border-radius: 0;
  border-style: solid;
  border-width: thin;
  border-color: rgba(255, 255, 255, 0.12);
  opacity: 0.8;
}
</style>
